import { createAsyncThunk } from "@reduxjs/toolkit";
import { LocationManagement } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindLocationManagement, GetLocationManagement } from "../../locationManagement/api/interface";

export const findSelectLocationManagement = createAsyncThunk(
  "selectLocationManagement/findSelectLocationManagement",
  async (values: FindLocationManagement, { rejectWithValue }) => {
    try {
      const response = await LocationManagement.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectLocationManagement = createAsyncThunk(
  "selectLocationManagement/searchSelectLocationManagement",
  async (values: FindLocationManagement, { rejectWithValue }) => {
    try {
      const response = await LocationManagement.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectLocationManagement = createAsyncThunk(
  'selectLocationManagement/getSelectLocationManagement',
  async ({ id }: GetLocationManagement, { rejectWithValue }) => {
    try {
      const response = await LocationManagement.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
